import { createSlice } from "@reduxjs/toolkit";
import { addChefImageAPI } from "../../api/chef";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const addChefImageSlice = createSlice({
  name: "addChefImage",
  initialState: data,
  reducers: {
   addChefImageSlice(state) {
      state.isLoading = true;
    },
   addChefImageSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    addChefImageSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   addChefImageSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const addChefImageHandler = (data:any) => async (dispatch: any) => {
  try {
    dispatch(addChefImageAction.addChefImageSlice());
    const response: any = await addChefImageAPI(data);
    
    dispatch(addChefImageAction.addChefImageSliceSuccess(response));
  } catch (e: any) {
    dispatch(addChefImageAction.addChefImageSliceFailure(e?.response?.data));
  }
};
export default addChefImageSlice.reducer;
export const addChefImageAction = addChefImageSlice.actions;
